<fidelity-overlay-page-wrapper
    *transloco="let t; prefix 'fidelity-app'"
    [headerCaption]="t('account.fiscal.heading')"
    [errorComponent]="errorComponent()"
>
    <div pageContent class="h-full grid grid-cols-1"
         [ngStyle]="{'grid-template-rows': fetchingData() ? 'auto':'1fr auto' }" *transloco="let gt">
        @if (fetchingData()) {
            <generic-page-loading-state class="text-tb-primary my-auto"></generic-page-loading-state>
        } @else {
            <div class="overflow-auto p-4">

                <h2 class="text-start w-full mb-4">
                    {{ t('account.fiscal.fiscal-title') }}
                </h2>
                <div [formGroup]="fiscalForm" class="w-full grid grid-cols-1 gap-y-4">
                    <!-- Business name -->
                    <mat-form-field>
                        <mat-label>
                            {{ t('account.fiscal.business-name') }}
                        </mat-label>
                        <input matInput formControlName="businessName" #businessName>
                        <mat-hint align="start">{{ gt('hints.max-length', { max: MAX_LENGTHS.FISCAL_DATA.BUSINESS_NAME }) }}
                        </mat-hint>
                        <mat-hint align="end">{{ businessName.value.length }}/ {{ MAX_LENGTHS.FISCAL_DATA.BUSINESS_NAME }}</mat-hint>
                        @if (fiscalForm.get('businessName')?.hasError('minlength')) {
                            <mat-error>{{ gt('validation.min-length') }}</mat-error>
                        }
                        @if (fiscalForm.get('businessName')?.hasError('maxlength')) {
                            <mat-error>{{ gt('validation.max-length') }}</mat-error>
                        }
                    </mat-form-field>

                    <!-- Fiscal code -->
                    <mat-form-field>
                        <mat-label>
                            {{ t('account.fiscal.fiscal-code') }}
                        </mat-label>
                        <input matInput formControlName="fiscalCode" #fiscalCode>
                        <mat-hint align="start">{{ gt('hints.exact-length', { len: MAX_LENGTHS.FISCAL_DATA.FISCAL_CODE }) }}
                        </mat-hint>
                        <mat-hint align="end">{{ fiscalCode.value.length }}/ {{ MAX_LENGTHS.FISCAL_DATA.FISCAL_CODE }}</mat-hint>
                        @if (fiscalForm.get('fiscalCode')?.hasError('minlength')) {
                            <mat-error>{{ gt('validation.min-length') }}</mat-error>
                        }
                        @if (fiscalForm.get('fiscalCode')?.hasError('maxlength')) {
                            <mat-error>{{ gt('validation.max-length') }}</mat-error>
                        }
                    </mat-form-field>

                    <!-- Vat number -->
                    <mat-form-field>
                        <mat-label>
                            {{ t('account.fiscal.vat-number') }}
                        </mat-label>
                        <input matInput formControlName="vatNumber" #vatNumber>
                        <mat-hint align="start">{{ gt('hints.exact-length', { len: MAX_LENGTHS.FISCAL_DATA.VAT_NUMBER }) }}
                        </mat-hint>
                        <mat-hint align="end">{{ vatNumber.value.length }}/ {{ MAX_LENGTHS.FISCAL_DATA.VAT_NUMBER }}</mat-hint>
                        @if (fiscalForm.get('vatNumber')?.hasError('minlength')) {
                            <mat-error>{{ gt('validation.min-length') }}</mat-error>
                        }
                        @if (fiscalForm.get('vatNumber')?.hasError('maxlength')) {
                            <mat-error>{{ gt('validation.max-length') }}</mat-error>
                        }
                    </mat-form-field>

                    <!-- sdi -->
                    <mat-form-field>
                        <mat-label>
                            {{ t('account.fiscal.sdi') }}
                        </mat-label>
                        <input matInput formControlName="sdiCode" #sdiCode>
                        <mat-hint align="start">{{ gt('hints.exact-length', { len: MAX_LENGTHS.FISCAL_DATA.SDI_CODE }) }}
                        </mat-hint>
                        <mat-hint align="end">{{ sdiCode.value.length }}/ {{ MAX_LENGTHS.FISCAL_DATA.SDI_CODE }}</mat-hint>
                        @if (fiscalForm.get('sdiCode')?.hasError('minlength')) {
                            <mat-error>{{ gt('validation.min-length') }}</mat-error>
                        }
                        @if (fiscalForm.get('sdiCode')?.hasError('maxlength')) {
                            <mat-error>{{ gt('validation.max-length') }}</mat-error>
                        }
                    </mat-form-field>

                </div>
            </div>

            <button
                matRipple
                mat-flat-button
                [disabled]="disableSave()"
                class="fuse-mat-button-large m-4 mb-0 enabled:bg-tb-primary enabled:text-tb-primary-contrast"
                (click)="saveChanges()"
            >
                @if (disableCrudActions()) {
                    <mat-progress-spinner
                        [diameter]="24"
                        [mode]="'indeterminate'"
                    ></mat-progress-spinner>
                } @else {
                    {{ gt('generic.save') }}
                }
            </button>
        }
    </div>
</fidelity-overlay-page-wrapper>
